// extracted by mini-css-extract-plugin
module.exports = {"catalog":"App_catalog__2MtwQ","navbar":"App_navbar__2EMvI"};